import { articleCategories } from "@luntero/db/contracts/articles";
import type { ArticleCategory } from "@luntero/db/contracts/articles";
export {
  articleCategories,
  type ArticleCategory,
} from "@luntero/db/contracts/articles";
import { z } from "zod";

export const articleHeaderGraphic: Record<ArticleCategory, string> = {
  FIND_HOME: "/assets/resource/accent-images/find-home.webp",
  PLATFORMS: "/assets/resource/accent-images/rental-platforms.webp",
  TEMPLATES: "/assets/resource/accent-images/templates.webp",
  UTILITIES: "/assets/resource/accent-images/utilities.webp",
  RENTAL_LAWS: "/assets/resource/accent-images/rental-laws.webp",
  LANDLORD_TIPS: "/assets/resource/accent-images/landlord-tips.webp",
  MAINTENANCE: "/assets/resource/accent-images/maintenance.webp",
  MOVING: "/assets/resource/accent-images/moving.webp",
  SECURITY: "/assets/resource/accent-images/security.webp",
  SUSTAIN: "/assets/resource/accent-images/sustain.webp",
  FINANCE: "/assets/resource/accent-images/finance.webp",
  MARKET_COMPARE: "/assets/resource/accent-images/market-compare.webp",
  LIFESTYLE: "/assets/resource/accent-images/lifestyle.webp",
  COMMUNITY: "/assets/resource/accent-images/community.webp",
  NEWS: "/assets/resource/accent-images/news.webp",
};

export const articleCategoriesSlugs: Record<ArticleCategory, string> = {
  FIND_HOME: "find-home",
  PLATFORMS: "rental-platforms",
  TEMPLATES: "templates",
  UTILITIES: "utilities",
  RENTAL_LAWS: "rental-laws",
  LANDLORD_TIPS: "landlord-tips",
  MAINTENANCE: "maintenance",
  MOVING: "moving",
  SECURITY: "security",
  SUSTAIN: "sustain",
  FINANCE: "finance",
  MARKET_COMPARE: "market-compare",
  LIFESTYLE: "lifestyle",
  COMMUNITY: "community",
  NEWS: "news",
};

export const getArticleCategorySlug = (category: ArticleCategory): string => {
  return articleCategoriesSlugs[category];
};

export const getArticleCategoryFromSlug = (
  slug: string
): ArticleCategory | null => {
  for (const category of articleCategories) {
    if (articleCategoriesSlugs[category] === slug) {
      return category;
    }
  }
  return null;
};

export const articleCreateSchema = z.object({
  englishArticleId: z.string().nullable(),
  title: z.string(),
  descriptionShort: z.string(),
  descriptionSEO: z.string(),
  slug: z.string(),
  language: z.string(),
  category: z.enum(articleCategories),
  content: z.string(),
  locationId: z.string().nullable(),
});

export const articleSortTypes = [
  "DATE_DESC",
  "DATE_ASC",
  "A-Z",
  "Z-A",
] as const;

export type ArticleSortType = (typeof articleSortTypes)[number];
